// extracted by mini-css-extract-plugin
module.exports = {"deferredIcon":"deferredIcon_deferredIcon__5FbZP"};